import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicSelect from "./BasicSelect/BasicSelect";
import MultiSelectComp from "./MultiSelect/MultiSelectComp";

const SelectPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Select"}
        description={
          "Select components are used for collecting user provided information from a list of options."
        }
      />
      <Divider light />
      <BasicSelect />
      <MultiSelectComp />
    </Paper>
  );
};

export default SelectPage;
